module.exports = __webpack_public_path__ + "static/media/hd-signature1.ae8c460d.jpg";